import { StyledSpan } from "./styled"
import { TSpanProps } from "./types"

export const SpanColor = ({
    bgColor,
    children,
    ...props
}:TSpanProps) => {
    return (
        <StyledSpan bgColor={bgColor}>{children}</StyledSpan>
    )
}